module.exports = __webpack_public_path__ + "static/img/202.9530011b.gif";